import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

import { ITimecardDetailDTO, ITimecardPeriodDTO, ITimecardSummaryDTO } from 'src/api/dtos';
import { IError } from 'src/api/types';

import { fetchTimecardDetails, fetchTimecardPeriods, fetchTimecardSummary } from './timecard.actions';
import { ITimecardState } from './timecard.types';

const initialState: ITimecardState = {
  currentSummary: null,
  details: [],
  summary: null,
  periods: [],
  loadingDetails: false,
  loadingSummary: false,
  error: null,
};

export const timecardSlice = createSlice({
  name: 'timecard',
  initialState,
  reducers: {},
  extraReducers: (build) => {
    /* fetchTimecardPeriods */
    build.addCase(
      fetchTimecardPeriods.fulfilled.type,
      (
        state: Draft<ITimecardState>,
        {
          payload,
        }: PayloadAction<{
          periods: ITimecardPeriodDTO[];
          currentSummary: ITimecardSummaryDTO;
        }>,
      ) => {
        return {
          ...state,
          periods: payload.periods,
          currentSummary: payload.currentSummary,
          error: null,
        };
      },
    );
    build.addCase(
      fetchTimecardPeriods.rejected.type,
      (state: Draft<ITimecardState>, { payload }: PayloadAction<IError>) => {
        return {
          ...state,
          error: payload,
        };
      },
    );
    /* fetchTimecardSummary */
    build.addCase(
      fetchTimecardSummary.fulfilled.type,
      (state: Draft<ITimecardState>, { payload }: PayloadAction<ITimecardSummaryDTO>) => {
        return {
          ...state,
          summary: payload,
          loadingSummary: false,
        };
      },
    );
    build.addCase(fetchTimecardSummary.pending.type, (state: Draft<ITimecardState>) => {
      return {
        ...state,
        error: null,
        loadingSummary: true,
      };
    });
    build.addCase(
      fetchTimecardSummary.rejected.type,
      (state: Draft<ITimecardState>, { payload }: PayloadAction<IError>) => {
        return {
          ...state,
          error: payload,
          loadingSummary: false,
        };
      },
    );
    /* fetchTimecardDetails */
    build.addCase(
      fetchTimecardDetails.fulfilled.type,
      (state: Draft<ITimecardState>, { payload }: PayloadAction<ITimecardDetailDTO[]>) => {
        return {
          ...state,
          details: payload,
          loadingDetails: false,
        };
      },
    );
    build.addCase(fetchTimecardDetails.pending.type, (state: Draft<ITimecardState>) => {
      return {
        ...state,
        error: null,
        loadingDetails: true,
      };
    });
    build.addCase(
      fetchTimecardDetails.rejected.type,
      (state: Draft<ITimecardState>, { payload }: PayloadAction<IError>) => {
        return {
          ...state,
          error: payload,
          loadingDetails: false,
        };
      },
    );
  },
});
